// routes/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../utility/auth";
import { isHost } from "../utility/auth";
const HostRoute = ({ element: Element }) => {
  return isAuthenticated() && isHost() ? <Element /> : <Navigate to="/" replace />;
};

export default HostRoute;
